import type { SuccessDefinition } from '@/flows/types';
import { TickBadgeIcon } from '@/components/icons';
import { ResponseFeedback } from './ResponseFeedback';

type NextStep = { id: string; label: string };
type SuccessLike = {
  summaryLine: string;
  nextSteps: NextStep[];
};

interface SuccessOutcomeProps<TDraft, TResult extends SuccessLike> {
  draft: TDraft;
  result: TResult;
  definition: SuccessDefinition<TDraft, TResult>;
}

export function SuccessOutcome<TDraft, TResult extends SuccessLike>({
  draft,
  result,
  definition,
}: SuccessOutcomeProps<TDraft, TResult>) {
  return (
    <section className="success-card" aria-labelledby="success-title">
      <div className="success-card__box">
        <div className="success-card__banner">
          <TickBadgeIcon className="success-card__banner-icon" size={22} variant="success" />
          <span id="success-title" className="success-card__banner-text">
            {definition.bannerText(result, draft)}
          </span>
        </div>
        <p className="success-card__summary">{result.summaryLine}</p>
        <p className="success-card__note">{definition.noteText}</p>
        <div className="success-card__divider" />
        <p className="success-card__next-label">Recommended next steps.</p>
        <div
          className={`success-card__next-list${result.nextSteps.length >= 4 ? ' success-card__next-list--grid' : ''}`}
        >
          {result.nextSteps.map((step) => (
            <button key={step.id} type="button" className="success-card__next-item">
              {step.label}
            </button>
          ))}
        </div>
      </div>
      <ResponseFeedback />
    </section>
  );
}
